import { InjectionToken } from '@angular/core';

export const ENV = new InjectionToken<unknown>('env');
